import { FieldName } from '@thurstech/commons/dist/entity/user';
import * as yup from 'yup';

import { getFileSchema } from '../common';
const LINK_REGEX = /^https?:\/\/(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(?:\/[^\s]*)?$/;

export const websiteDetailSchemma = yup.object({
  primaryColor: yup
    .string()
    .matches(/^#?([0-9a-fA-F]{3}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/, 'Primary Color should be a valid hex code')
    .required('Primary Color is required.'),
  secondaryColor: yup
    .string()
    .matches(
      /^#?([0-9a-fA-F]{3}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/,
      'Secondary Color should be a valid hex code'
    )
    .required('Secondary Color is required'),
  domain: yup
    .string()
    .matches(
      /^(([a-z0-9-]+\.)*[a-z0-9-]+\.[a-z]{2,})|localhost:\d+$|^$/,
      'Domain is Invalid. Domain should only contain lowercase letters, numbers, and hyphens'
    ),
  logo: getFileSchema(['image/']).required('Logo is required'),
  title: yup.string().required('Title is required'),
  description: yup.string().max(500).required('Description is required'),
  categories: yup
    .array(
      yup.object({
        title: yup.string().required('Category Title is required'),
        image: getFileSchema(['image/']).required('Category Image is required')
      })
    )
    .required('Atleast 1 Category is required')
    .min(1, 'Atleast 1 Category is required'),
  categoriesTitle: yup.string().required(),
  aggregatedStatTitle: yup.string().required(),
  aggregatedStat: yup.string().required(),
  ratingTitle: yup.string().required(),
  rating: yup.string().required(),
  landingImages: yup
    .array(getFileSchema(['image/']).required())
    .max(5)
    .required('Landing Images are required'),
  faqs: yup
    .array(
      yup.object({
        question: yup.string().required('Question is required'),
        answer: yup.string().required('Answer is required')
      })
    )
    .required('Atleast 1 FAQ is required')
    .min(1, 'Atleast 1 FAQ is required'),
  termsAndCondition: yup.string().required('Terms and Conditions is required'),
  cancellationPolicy: yup.string().required('Cancellation Policies is required'),
  privacyPolicy: yup.string().required('Privacy Policies is required'),
  isCancellationAllowed: yup.boolean().required(),
  cancellation: yup
    .object({
      minTime: yup.number().when('isCancellationAllowed', {
        is: true,
        then: schema => schema.required('Minimum Time is required')
      })
    })
    .default(undefined),
  links: yup.object({
    facebook: yup.string().min(1).matches(LINK_REGEX, 'Facebook should be a valid link'),
    instagram: yup.string().min(1).matches(LINK_REGEX, 'Instagram should be a valid link'),
    youtube: yup.string().min(1).matches(LINK_REGEX, 'Youtube should be a valid link')
  }),
  about: yup.object({
    title: yup.string().required('Title is required'),
    description: yup.string().max(500).required('Description is required'),
    images: yup
      .array(getFileSchema(['image/']).required())
      .max(4)
      .required('Images are required')
  }),
  dataToCollect: yup.object(
    Object.values(FieldName)
      .map(name => ({
        [name]: yup.object({
          collect: yup.bool().required(),
          required: yup.bool().when('collect', {
            is: true,
            then: schema => schema.required()
          })
        })
      }))
      .reduce((prev, current) => {
        const key = Object.keys(current)[0];
        prev[key] = current[key];
        return prev;
      }, {}) as Record<FieldName, yup.ObjectSchema<{ collect: boolean; required: boolean }>>
  ),
  productTitle: yup.string().required(),
  videoSection: yup
    .object({
      title: yup.string(), //.required('Video Section Title is required'),
      description: yup.string().max(500), //.required('Video Section Description is required'),
      videos: yup.array(
        yup.object({
          src: getFileSchema(['video/']), //.required('Video file is required'),
          thumbnail: getFileSchema(['image/'])
        })
      )
      // .required('At least 1 video is required')
      // .min(1, 'At least 1 video is required')
      // .max(5, 'Maximum 5 videos allowed')
    })
    .required('Video section is required')
});

export type WebsiteDetailFormData = yup.InferType<typeof websiteDetailSchemma>;
